import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-edit\"><defs><style type=\"text/css\"></style></defs><path d=\"M633.018182 167.563636L791.272727 0 1024 232.727273 865.745455 390.981818 633.018182 167.563636zM0 791.272727V1024h223.418182l558.545454-558.545455L558.545455 232.727273l-558.545455 558.545454z\" fill=\"#888888\" p-id=\"2174\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol